// @flow
export const AvailabilityStatus = {
  UNVERIFIED: 'UNVERIFIED',
  VERIFYING: 'VERIFYING',
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const DomainStatus = {
  AVAILABLE: 'AVAILABLE',
  VOID: 'VOID',
  TAKEN: 'TAKEN',
  PROMO: 'PROMO',
};

export const Hook = {
  ADD_TO_BASKET: '@dst/domain_purchase_requested',
  ADD_BUNDLE_TO_BASKET: '@dst/domain_bundle_purchase',
  VIEW_BASKET: '@dst/view_basket',
  BACKORDER: '@dst/backorder_domain',
  TRANSFER: '@dst/transfer_domain',
  NEGOTIATE: '@dst/negotiate_domain',
  SEARCHING: '@dst/searching',
};

export const ModalRoute = {
  NEGOTIATE: '/negotiate',
};
